module.exports = __webpack_public_path__ + "static/media/4.02b813f9.webp";